import React, { useEffect, useState } from "react";
import Masonry from "react-masonry-css";
import { useSelector } from "react-redux";

import { NotifyBenefitContainer } from "../styled/dashboard";

const Benefit = () => {
  const [temp, setTemp] = useState([]);
  const user = useSelector((state) => state?.user?.data[0]);

  useEffect(() => {
    createAdData();
  }, []);

  function createAdData() {
    const adData = [];
    const tags = ["10% 할인 쿠폰", "에어팟 맥스 응모권", "성심당"];

    for (let i = 0; i < 1; i++) {
      adData.push({
        adName: `스탬프 모으면 선물이 팡팡`,
        adDescription: `상생매장 스탬프 투어! 스탬프를 모아 상생센터로 가져오시면 다양한 선물을 제공해드립니다!`,
        tag: tags[Math.floor(Math.random() * tags.length)],
        storeNm: "모노티 스탬프 투어",
        createdAt: new Date().toISOString(),
        category: "대전",
        virtualImage: `/img/sungsimdang/sungsimdang_coupon.png`,
      });
    }

    setTemp(adData);
  }

  const breakpointColumnsObj = {
    default: 3,
    1400: 3,
    1050: 2,
    767: 1,
  };

  const openAdvertisementPage = async () => {
    window.open(`https://1472.ai/shop/lotteria-daejeon`);
  };

  return (
    <NotifyBenefitContainer>
      {temp && temp.length > 0 && (
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column">
          {temp.map((item) => (
            <div className="box" onClick={() => alert("준비 중입니다.")}>
              <div className="store">
                <img src="/img/logo.png" alt="" />
                <span className="name">{item.storeNm}</span>
                <span>{item.category}</span>
              </div>
              <div className="product">
                <div className="info">
                  <span>{item.adName}</span>
                  <span>{item.adDescription}</span>
                  <span className="tag">{item.tag}</span>
                </div>
                <img src={item.virtualImage} />
              </div>
            </div>
          ))}
        </Masonry>
      )}
    </NotifyBenefitContainer>
  );
};

export default Benefit;
